import type { TOC } from '@ember/component/template-only';

import BarLoaderComponent from 'webapp/components/bar-loader';

const MobileGoalsLoadingRouteTemplate: TOC<object> = <template>
	<div class="loader-ct">
		<BarLoaderComponent @size="big" />
	</div>
</template>;

export default MobileGoalsLoadingRouteTemplate;
